import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './store/authStore';
import Login from '@/features/auth/pages/Login';
import Layout from './components/Layout';
import { APP_ROUTES } from '@/constants/routes';
import { PROTECTED_ROUTES } from '@/config/protected-routes';

/**
 * App router with a single auth gate:
 * - unauthenticated users can only access /login
 * - authenticated users see the shared layout and child pages
 */
function App() {
  const { isAuthenticated } = useAuthStore();

  return (
    <Routes>
      <Route
        path={APP_ROUTES.login}
        element={!isAuthenticated ? <Login /> : <Navigate to={APP_ROUTES.home} replace />}
      />
      <Route
        path={APP_ROUTES.home}
        element={
          isAuthenticated ? (
            <Layout />
          ) : (
            <Navigate to={APP_ROUTES.login} replace />
          )
        }
      >
        {PROTECTED_ROUTES.map((route) => {
          const Component = route.component;
          if (route.index) {
            return <Route key="index" index element={<Component />} />;
          }

          if (!route.path) {
            return null;
          }

          return <Route key={route.path} path={route.path} element={<Component />} />;
        })}
      </Route>
      <Route path="*" element={<Navigate to={APP_ROUTES.home} replace />} />
    </Routes>
  );
}

export default App;
